import React from 'react'
import useSettingsManager from '../hooks/use-settings-manager'
import Info from '../port-image/Info'

function ImageInfo () {

  const settings_manager = useSettingsManager()
  const string = settings_manager.getOtherSettings('image_info', '')

  return (typeof string === 'string' && string.length > 0) ? <Info text={string}/> : null
}

export default ImageInfo